export default __webpack_public_path__ + "static/Marketing-2675693084187b5f0658c1f085cc656b.png";